import React, { Component } from "react";
import history from "../login/history";
import CabalTitulo from "./CabalTitulo";
import {mensajeExito} from "../../generico/MensajeSistemaToast";
import PagoServicioServiceV2 from "../../../services/pagoServicios/pagoServicioServiceV2";
import AuthService from "../../../services/login/auth.service";
import { trackPromise } from "react-promise-tracker";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faArrowLeft, faMoneyCheckDollar } from "@fortawesome/free-solid-svg-icons";
import DataTable from 'react-data-table-component';
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";

export default class SicoopPaso4 extends Component {
  constructor(props) {
    super(props);
    this.datos = undefined;
    this.monto = 0;
    this.state = {
      codigo: props.codigo,
      datos:undefined,
      datosObtenidos:false
    };
  }

  componentDidMount() {

  }
  descargar = async () => {
    let cuentaSeleccionada = JSON.parse(JSON.stringify(this.props.cuentaOrigenSelected));
    let datosSocio = JSON.parse(sessionStorage.getItem('socio'));
    let formaPago;
    formaPago = this.props.modalidaPago === 'TCO' ? 'TARJETA' : 'CUENTA DE AHORRO' ;
    let config= {
      titulo : this.props.nombreServicio,
      nroSocioTitular:datosSocio.numeroSocio,
      nroOperacion:this.props.nroOperacion,
      formaPago:formaPago,
      cuentaDebito:cuentaSeleccionada?.ahorro,
      detalles: this.props.comprobante
    };
    await trackPromise(
      // PagoServicioServiceV2.descargarComprobante("Pagos de Servicios", this.props.nroOperacion, AuthService.getSocio().numeroSocio.trim() +" - "+AuthService.getSocio().nombreCompleto, this.props.cuenta, this.props.paso4)
      PagoServicioServiceV2.descargarComprobante(config)
        .then((response) => {
          console.log('EXITO');
          console.log(response);
          let fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  };
  volver = (e) => {
    history.push(ConfigService.getPathByName("pagoServicioCabal")?.url);
    window.location.reload();
  }

  home = (e) => {
    history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
    window.location.reload();
  }

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      }]
  }

  getDatos(){
    let respuesta = [];
    let numeroTarjetaCuenta = undefined;
    let valor = this.props.comision === undefined ? this.props.monto : (parseInt(this.props.monto) + parseInt(this.props.comision));
    this.monto = valor;
    valor = undefined;
    if( this.props.modalidadPago === 'TCO' ){
      numeroTarjetaCuenta = this.props.cuentaOrigenSelected.value
      respuesta.push({
        concepto : 'Forma de Pago:',
        valor : 'TARJETA CRÉDITO - ' + this.props.tipoTarjeta
      });
      respuesta.push({
        concepto:'Nro de Tarjeta:',
        valor:numeroTarjetaCuenta.substring(0,4) + '****'+
        numeroTarjetaCuenta.substring(numeroTarjetaCuenta.length - 4 , numeroTarjetaCuenta.length)
      });
    }else{
      respuesta.push({
        concepto: 'Forma de Pago:',
        valor : 'AHORRO VISTA'
      });
      respuesta.push({
        concepto : 'Nro de Cuenta:',
        valor:this.props.cuentaOrigenSelected.ahorro
      })
    }

    console.log(this.props.comprobante);

    // this.props.comprobante[0].concepto = 'Total Pagado:';
    this.props.comprobante.shift();
    console.log(this.props.cuentaOrigenSelected);
    console.log({
      respuesta : respuesta
    })
    for( let i = 0 ; i < this.props.comprobante.length ; i++ ){
      respuesta.push({
        concepto: this.props.comprobante[i].concepto,
        valor : this.props.comprobante[i].valor
      })
    }
    this.datos = respuesta;
    this.setState({ datos : respuesta , datosObtenidos : true });



  }

  render() {
    if (this.props.currentStep !== 5) { // Prop: The current step
      return null
    }
    if(this.props.currentStep===5){
      if( this.state.datosObtenidos === false ){
        this.getDatos();
        mensajeExito("El Pago se Realizó Correctamente");
      }
      console.log({
        MONTO:this.props.monto,
        COMISION:this.props.comision,
        MODALIDAD_PAGO:this.props.modalidadPago,
        TIPO_TARJETA:this.props.tipoTarjeta
      });
    } 
    return (
      <div>
        {/******************* CABECERA WIZARD ***********************/}
        <div className="row">
          <div class="steps clearfix" style={{marginBottom:5}}>
            <ul role="tablist">
              <li role="tab" class="disabled">
                <span>
                  <div class="title">
                    <span class="title_text">{this.props.nombre}</span>
                  </div>
                </span>
              </li>
              <li role="tab" class="disabled">
                <span>
                  <div class="title">
                    <span class="title_text">Consulta</span>
                  </div>
                </span>
              </li>
              <li role="tab" class="disabled">
                <span>
                  <div class="title">
                    <span class="title_text">Cuenta</span>
                  </div>
                </span>
              </li>
              <li role="tab" class="disabled">
                <span>
                  <div class="title">
                    <span class="title_text">Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" class="current">
                <span>
                  <div class="title">
                    <span class="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <CabalTitulo img={this.props.img} empresa={this.props.empresa} />
        <hr/>

        {/******************* LOGICA PASOS ***********************/}
        <div className="row justify-content-md-center">
          <div className="col-md-10" style={{textAlign: "end"}}>
            <p className="nro-operacion">
              Número de Operación: {this.props.nroOperacion}                        
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <h6 style={{ margin: 0 }}>
              Socio: {AuthService.getSocio().numeroSocio.trim()} -{" "}
              {AuthService.getSocio().nombreCompleto}
            </h6>
            {/* <p style={{ marginBottom: 0 }}>
              Cuenta: {this.props.cuenta}
            </p> */}
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-lg-5 col-md-8">
            <br/>
            <label className="input-label-bold">Comprobante del Pago</label>
            <div className="row">
              <DataTable
                noHeader={true}
                columns={this.getColumn()}
                data={this.datos}
                dense={true}
                noDataComponent="No se tiene datos que mostrar"
                responsive={true}
                noTableHead={true} 
              />
            </div>
            
            {/* <pre className="pago-servicio-comprobante"> */}
              {/* {this.props.paso4} */}
            {/* </pre> */}
          </div>  
        </div>
        <div className="row justify-content-md-center">
              <div className="col-md-8">
                <label className="input-label-bold">
                  Total pagado:
                </label>
              </div>
              <div className="col-md-2">
                <label className="input-label-bold">
                  {formatoSeparadorMilesValue(this.monto)}
                </label>
              </div>
            {/* <label className="input-label-bold">Total pagado:{(parseInt(this.props.comision)+parseInt(this.props.monto))}</label> */}
            </div>
        <hr />
        <div className="row">
          <div className="col-md-4 btn-consulta">
          <button className="btn btn-cu-secundary"onClick={this.volver}>
          <FontAwesomeIcon icon={faMoneyCheckDollar} />  Pagar Otro Servicio</button>
          </div>
          <div className="col-md-4 btn-consulta"><button className="btn btn-cu-quintary" onClick={this.home}><FontAwesomeIcon icon={faArrowLeft} /> Volver al Inicio</button>
          </div>
          <div className="col-md-4">
          <button className="btn btn-cu-primary" onClick={this.descargar}><FontAwesomeIcon icon={faDownload} /> Descargar Comprobante</button>
          </div>
          
          
          
        </div>
      </div>
    );
  }
}